module.exports = __webpack_public_path__ + "fonts/google-logo.svg";